import { useEffect, useRef } from 'react';
import { useContainerLayout } from 'shared/utils';

export const useActivityListHeightObserver = () => {
    const activityListRef = useRef<HTMLDivElement>(null);
    const sideMenuFooterRef = useRef<HTMLDivElement>(null);

    const activityListLayout = useContainerLayout(activityListRef);
    const sideMenuFooterLayout = useContainerLayout(sideMenuFooterRef);

    // handle activity list height
    useEffect(() => {
        if (!activityListLayout.screenTop || !sideMenuFooterLayout.screenTop || !activityListRef.current) {
            return;
        }
        const height = Math.max(0, sideMenuFooterLayout.screenTop - activityListLayout.screenTop);
        activityListRef.current.style.height = `${height}px`;
    }, [activityListLayout, sideMenuFooterLayout]);

    return { activityListRef, sideMenuFooterRef };
};
